module.exports = __webpack_public_path__ + "img/finalgrace.48a9b775.png";